import { UseMutationOptions, useMutation } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import {
  ErrorResponse,
  SetVerificationCodeInput,
  SetVerificationCodeResponse,
  setVerificationCodeResponseSchema,
} from '../../../common/validations'

import { post } from 'api/apiClient'

export const useAPISetVerificationCode = (
  options?: UseMutationOptions<
    SetVerificationCodeResponse,
    ErrorResponse,
    SetVerificationCodeInput
  >
) =>
  useMutation({
    mutationFn: (data) =>
      post(
        API_ENDPOINTS.SET_VERIFICATION_CODE,
        data,
        setVerificationCodeResponseSchema
      ),
    throwOnError: false,
    ...options,
  })
